import axios from "axios";

export const SESSION_INVALID_EVENT = "driveshop:session-invalid";

export function hasExpiredToken() {
  const token = localStorage.getItem("fmsToken");
  const expiry = localStorage.getItem("fmsTokenExpiry");
  if (!token || !expiry) return false;
  const timestamp = Date.parse(expiry);
  return !Number.isFinite(timestamp) || timestamp <= Date.now();
}

export function notifyInvalidSession() {
  window.dispatchEvent(new Event(SESSION_INVALID_EVENT));
}

let interceptorInstalled = false;
export function installSessionInterceptor() {
  if (interceptorInstalled) return;
  interceptorInstalled = true;
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const url = error.config && error.config.url ? error.config.url : "";
      // Invalid login credentials shouldn't display a session-expired warning.
      if (error.response && error.response.status === 401 && !/\/login(?:\?|$)/.test(url)) {
        notifyInvalidSession();
      }
      return Promise.reject(error);
    }
  );
}
